import {Game} from "./types";
import {colorBlue} from "../shared/colors";
import {WorldDifficultyLevel} from "./games/map/world/types";
import {WorldGameFragment} from "./games/map/world/WorldGameFragment";
import {GameFragmentListener} from "./games/GameFragment";
import {EuropeGameFragment} from "./games/map/europe/EuropeGameFragment";
import {EuropeDifficultyLevel} from "./games/map/europe/types";
import {AfricaDifficultyLevel} from "./games/map/africa/types";
import {AfricaGameFragment} from "./games/map/africa/AfricaGameFragment";
import {AsiaGameFragment} from "./games/map/asia/AsiaGameFragment";
import {AsiaDifficultyLevel} from "./games/map/asia/types";
import {NorthAmericaGameFragment} from "./games/map/north_america/NorthAmericaGameFragment";
import {NorthAmericaDifficultyLevel} from "./games/map/north_america/types";
import {SouthAmericaDifficultyLevel} from "./games/map/south_america/types";
import {SouthAmericaGameFragment} from "./games/map/south_america/SouthAmericaGameFragment";
import {AustraliaGameFragment} from "./games/map/australia/AustraliaGameFragment";
import {AustraliaDifficultyLevel} from "./games/map/australia/types";
import {
  AFRICA_COUNTRIES,
  ASIA_COUNTRIES,
  AUSTRALIA_COUNTRIES,
  Country,
  EUROPE_COUNTRIES,
  NORTH_AMERICA_COUNTRIES,
  SOUTH_AMERICA_COUNTRIES,
  WORLD_COUNTRIES
} from "./games/map/types";

export enum GameTabType {
  WORLD = "world",
  EUROPE = "europe",
  AFRICA = "africa",
  ASIA = "asia",
  NORTH_AMERICA = "north_america",
  SOUTH_AMERICA = "south_america",
  AUSTRALIA = "australia",
}

function renderDesc(countries: Country[]): string {
  return Math.min(30, countries.length) + " questions";
}

export const GAME_WORLD: Game = {
  id: GameTabType.WORLD,
  name: "World",
  description: renderDesc(WORLD_COUNTRIES),
  coverUrl: "/images/games/covers/world.svg",
  color: colorBlue,
  levels: WorldDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <WorldGameFragment path={path} gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAME_EUROPE: Game = {
  id: GameTabType.EUROPE,
  name: "Europe",
  description: renderDesc(EUROPE_COUNTRIES),
  coverUrl: "/images/games/covers/europe.svg",
  color: colorBlue,
  levels: EuropeDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <EuropeGameFragment path={path} gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAME_AFRICA: Game = {
  id: GameTabType.AFRICA,
  name: "Africa",
  description: renderDesc(AFRICA_COUNTRIES),
  coverUrl: "/images/games/covers/africa.svg",
  color: colorBlue,
  levels: AfricaDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <AfricaGameFragment path={path} gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAME_ASIA: Game = {
  id: GameTabType.ASIA,
  name: "Asia",
  description: renderDesc(ASIA_COUNTRIES),
  coverUrl: "/images/games/covers/asia.svg",
  color: colorBlue,
  levels: AsiaDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <AsiaGameFragment path={path} gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAME_NORTH_AMERICA: Game = {
  id: GameTabType.NORTH_AMERICA,
  name: "North America",
  description: renderDesc(NORTH_AMERICA_COUNTRIES),
  coverUrl: "/images/games/covers/north_america.svg",
  color: colorBlue,
  levels: NorthAmericaDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <NorthAmericaGameFragment path={path}
                                                       gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAME_SOUTH_AMERICA: Game = {
  id: GameTabType.SOUTH_AMERICA,
  name: "South America",
  description: renderDesc(SOUTH_AMERICA_COUNTRIES),
  coverUrl: "/images/games/covers/south_america.svg",
  color: colorBlue,
  levels: SouthAmericaDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <SouthAmericaGameFragment path={path}
                                                       gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAME_AUSTRALIA: Game = {
  id: GameTabType.AUSTRALIA,
  name: "Australia",
  description: renderDesc(AUSTRALIA_COUNTRIES),
  coverUrl: "/images/games/covers/australia.svg",
  color: colorBlue,
  levels: AustraliaDifficultyLevel.VALUES.map(level => {
    return {name: level.name, text: level.text};
  }),
  render: (path, ...args) => <AustraliaGameFragment path={path}
                                                    gameFragmentListener={args[0] as GameFragmentListener}/>,
};

export const GAMES: Game[] = [
  GAME_WORLD,
  GAME_EUROPE,
  GAME_AFRICA,
  GAME_ASIA,
  GAME_NORTH_AMERICA,
  GAME_SOUTH_AMERICA,
  GAME_AUSTRALIA,
];

export function getGameById(gameId: string): Game {
  return GAMES.find(game => game.id === gameId);
}